import React, { useState } from 'react';
import { get, last } from 'lodash';
import moment from 'moment';
import { object, func, string, array, bool} from 'prop-types';
import { withApollo } from 'react-apollo';
import { Row, Column, Title, Text, ConfirmFooterButtons } from '../../common';
import { _get  } from '../../../utils/misc';
import SEND_NOTIFICATION from '../../../queries/SEND_NOTIFICATION';



const OrderQr= ({ dataQr, id, storeName, isErrorQr, onClose, client, ...props }) => {
    const email = get(last(dataQr), 'shopper');
    const [loading, setLoading] = useState(false);
    const [mutationStatus, setMutationStatus] = useState(false);
    const [disabledButton, setDisabledButton] = useState(false);


    const onAcceptRequest = async () => {
        setLoading(true);
        setDisabledButton(true)

        client.mutate({
            mutation: SEND_NOTIFICATION,
            variables: { 
                input: {  
                    email: email,
                    notificationType: 34,
                    title: 'Puerta Embolsado Desbloqueada',
                    message: 'Embolsado Habilitado',
                    orderId: id
                }
            }
        }).then(() => {
            setMutationStatus('success');
            setLoading(false);
            setDisabledButton(true);
            setTimeout(() => onClose(), 1000);
        }).catch((error) => {
            console.error(error);
            setMutationStatus('error');
            setDisabledButton(false);
            setLoading(false);
        });
        
        
    };

    const RenderMutationStatus = () => {
        switch (mutationStatus) {
            case 'success':
                return (
                    <Text italic text='Notificación enviada con éxito.' strong color='#4c971f' />
                );
            case 'error':
                return (
                    <Text italic text='Error al enviar la notificación.' strong color='#db5959' />
                );
            default:
                return null;
        }
    };

    const formatDate = (dateString) => {
        if (!dateString || !moment(dateString).isValid()) return "-";
        return moment(dateString).format('DD/MM/YYYY HH:mm');
    };

    return (
        <div style={{ width: '100%', maxHeight: 'calc(100% - 120px)', overflowY: 'auto',  backgroundColor: "#fbfbfb" }}>
            <Row style={{ border: '1px solid #eaeaea', borderRadius: '3px', padding: '13px' }}>
                <Row>
                    <Column  width={120} >
                        <Row align='center' mB={10} mR={10}>
                            { isErrorQr && (
                                <>
                                    <Title text={`Motivo: `} style={{ minWidth: '11%' }}/>
                                    <Title text={`orders_qr_status.${get(last(dataQr), 'actionNumber')}`} style={{ minWidth: '11%' }}/>
                                </>
                            )} 
                        </Row>
                        <Row style={{ marginTop: '5px' }}>
                            <table style={{ width: '100%' }}>
                                <tbody>
                                    <tr>
                                        <td><Text text='Sala' semibold /></td>
                                        <td><Text text={storeName} /></td>
                                    </tr>
                                    <tr>
                                        <td><Text text='Fecha de generación' semibold /></td>
                                        <td><Text text={formatDate(get(last(dataQr), 'date'))} /></td>
                                    </tr>
                                    <tr>
                                        <td><Text text='Fecha de escaneo' semibold /></td>
                                        <td><Text text={formatDate(get(last(dataQr), 'updateDate'))} /></td>
                                    </tr>
                                    <tr>
                                        <td><Text text='Shopper' semibold /></td>
                                        <td><Text text={get(last(dataQr), 'shopper')} /></td>
                                    </tr>
                                    <tr>
                                        <td><Text text='QR paso por puerta' semibold /></td>
                                        <td><Text text={isErrorQr ? 'No' : 'Si'} /></td>
                                    </tr>
                                    
                                </tbody>
                            </table>
                        </Row>
                    </Column>
                </Row>
            </Row>
            <RenderMutationStatus/>
            {isErrorQr && <ConfirmFooterButtons  confirmDisabled={disabledButton} confirmLabel='Desbloquear'  onCancel={onClose} onConfirm={onAcceptRequest} loading={loading} /> }
        </div>
    );
};

OrderQr.propTypes = {
    dataQr: array,
    id: string,
    storeName: string,
    client: object,
    isErrorQr: bool,
    onClose: func,
};

OrderQr.defaultProps = {
    onClose: () => {},
    isErrorQr: false
};

export default withApollo(OrderQr);
